import {
    tss,
} from './config'

// https://docs.tss-react.dev/api/tss-usestyles

export default tss.withParams<{
    top?: number, left?: number, right?: number, bottom?: number
}>().create(({
    theme,
    top,
    left,
    right,
    bottom,
}) => {
    return {
        padding: {
            paddingTop: top ? theme.spacing(top) : 'auto',
            paddingLeft: left ? theme.spacing(left) : 'auto',
            paddingRight: right ? theme.spacing(right) : 'auto',
            paddingBottom: bottom ? theme.spacing(bottom) : 'auto',
        },
    }
})
